export const usePowerUps = (handleForm: any) => {
    const togglePowerUp = (powerUpName: string) => {
        const currentPowerUps = handleForm.values.powerUps || [];
        const existingIndex = currentPowerUps.findIndex((pu: any) => pu.name === powerUpName);
        
        if (existingIndex >= 0) {
            const updatedPowerUps = [...currentPowerUps];
            updatedPowerUps[existingIndex] = {
                ...updatedPowerUps[existingIndex],
                enabled: !updatedPowerUps[existingIndex].enabled
            };
            handleForm.setFieldValue('powerUps', updatedPowerUps);
        } else {
            handleForm.setFieldValue('powerUps', [
                ...currentPowerUps,
                { name: powerUpName, enabled: true }
            ]);
        }
    };

    const isPowerUpEnabled = (powerUpName: string) => {
        const powerUp = handleForm.values.powerUps?.find((pu: any) => pu.name === powerUpName);
        return powerUp?.enabled || false;
    };

    return { togglePowerUp, isPowerUpEnabled };
};